export default __webpack_public_path__ + "static/media/example.934cf25e.svg";